import {
  formatDateOrDash,
  formatDateTimeOrDash,
} from '#/utils/date';

function resolveToWarehouseName(warehouse) {
  if (!warehouse) {
    return '—';
  }

  return warehouse.name || warehouse.displayName || warehouse.id || '—';
}

function resolveToWarehouseLabel(warehouse) {
  if (!warehouse) {
    return '—';
  }

  const codeName = [warehouse.code, warehouse.name].filter(Boolean).join(' ');
  return codeName || warehouse.displayName || warehouse.id || '—';
}

export function mapStockTransferMeta(detail) {
  const lineCount = Array.isArray(detail?.lines)
    ? detail.lines.length
    : (detail?.lineCount != null ? detail.lineCount : null);

  return {
    code: detail?.transferNo || '-',
    status: detail?.status || '',
    transferDate: formatDateOrDash(detail?.transferDate),
    sourceType: detail?.sourceType || '-',
    toWarehouseName: resolveToWarehouseName(detail?.toWarehouse),
    toWarehouseLabel: resolveToWarehouseLabel(detail?.toWarehouse),
    issueReason: detail?.issueReason ?? '',
    remark: detail?.remark || '',
    createDate: formatDateTimeOrDash(detail?.record?.createdAt),
    reviseDate: formatDateTimeOrDash(detail?.record?.updatedAt),
    closeDate: formatDateTimeOrDash(detail?.history?.completedAt),
    lineCount,
  };
}
